import React from "react";
import { isMiniSize } from "@/utils";

class ImagePreView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgW: 0,
      imgH: 0,
      left: 0,
      top: 0,
      isLoading: true,
    };
  }

  maskClick() {
    if (this.props.maskClick) {
      this.props.maskClick();
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.resizeWindow);
  }

  componentDidUpdate(prevProps) {
    const { show } = this.props;
    if (!prevProps.show && show !== prevProps.show) {
      this.imgResize();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeWindow);
  }

  resizeWindow = () => {
    this.imgResize();
  };

  imgResize() {
    if (this.props.src) {
      const img = new Image();
      img.src = this.props.src;
      let imgW = this.state.imgW;
      let imgH = this.state.imgH;
      img.onload = () => {
        imgW = img.width;
        imgH = img.height;
        const ratio = imgH / imgW;
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        let leftArea = 80;
        let toptArea = 97;
        if (isMiniSize()) {
          leftArea = 0;
          toptArea = 70;
        }
        let marginGround = isMiniSize() ? 0 : 36;
        if (isMiniSize()) {
          imgW = windowWidth;
          imgH = ratio * imgW;
        } else {
          if (windowWidth - leftArea - marginGround < imgW) {
            imgW = windowWidth - leftArea - marginGround;
            imgH = ratio * imgW;
          }
        }
        if (windowHeight - toptArea - marginGround < imgH) {
          imgH = windowHeight - toptArea - marginGround;
          imgW = imgH / ratio;
        }

        let left = (windowWidth - leftArea - imgW) / 2;
        let top = (windowHeight - toptArea - imgH) / 2;
        this.setState({
          imgW: imgW,
          imgH: imgH,
          left: left,
          top: top,
          isLoading: false,
        });
      };
    }
  }

  render() {
    const { show, src } = this.props;
    const { isLoading } = this.state;
    const showStyle = show
      ? {
          display: "",
          top: `${this.state.top}px`,
          left: `${this.state.left}px`,
        }
      : { display: "none" };
    return (
      <div>
        {isLoading ? (
          ""
        ) : (
          <div className="img-pre-area" style={showStyle}>
            <div
              className="img-pre-area-close-icon"
              onClick={this.maskClick.bind(this)}
              tabIndex="0"
            >
              <span></span>
            </div>
            <img
              id="preImg"
              src={src}
              alt=""
              width={this.state.imgW}
              height={this.state.imgH}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ImagePreView;
